import { api } from "../../api";
import {
  ShippingCaseServiceResponse,
  PreloadFileResponse,
  SippingCasesRequest,
  SippingCasesUpdateRequest,
} from "./types";

import { ShippingCaseResponse } from "../shippingView/types";

export async function getShippingServicesApi(params: {
  offer_id: number;
}): Promise<ShippingCaseServiceResponse> {
  const { data } = await api.get<ShippingCaseServiceResponse>(
    "/api/activities/grouped",
    {
      params,
    },
  );
  return data;
}

export async function preloadFileByTypeApi(params: {
  filename: string;
  doc_type: string | null;
  offer_id: number;
}): Promise<PreloadFileResponse> {
  const { data } = await api.post<PreloadFileResponse>(
    `/api/files/upload/offers/${params.offer_id}/cargo-docs`,
    {
      ...params,
    },
  );
  return data;
}

export async function loadFileByTypeApi(params: {
  file: any;
  src: string;
}): Promise<void> {
  await fetch(params.src, {
    method: "PUT",
    body: params.file,
    headers: {
      "Content-Type": params.file.type,
    },
  });
}

export async function createShippinCaseApi(
  params: SippingCasesRequest,
): Promise<ShippingCaseResponse> {
  const { data } = await api.post<ShippingCaseResponse>(`/api/shipping-cases`, {
    ...params,
  });
  return data;
}

export async function updateShippinCaseApi(
  params: SippingCasesUpdateRequest,
): Promise<ShippingCaseResponse> {
  const { data } = await api.patch<ShippingCaseResponse>(
    `/api/shipping-cases/${params.sc_id}`,
    {
      ...params,
    },
  );
  return data;
}
